import { useMemo } from 'react';
import { Tooltip } from '@ds';
import { MdOutlineInfo } from 'react-icons/md';
import { FilterDropdown } from '@ui';
import { RouteTypeSettingsType } from '@lp/features/RoutePlanner/types';
import { RouteTypeSettingsEnum } from '@/api/apis/mission-planner';
import { ROUTE_TYPE_LIST_ITEMS, SUGGESTED_ROUTE_TYPE_NAME } from './config';
import { SuggestedSelectTrigger } from './SuggestedSelectTrigger';

type RouteTypeDropdownProps = {
  data: RouteTypeSettingsType;
  disabledRouteTypes: Partial<Record<RouteTypeSettingsEnum, string>>;
  handleRouteTypeChange: (value: RouteTypeSettingsEnum) => void;
};

export const RouteTypeDropdown = ({ data, disabledRouteTypes, handleRouteTypeChange }: RouteTypeDropdownProps) => {
  const disabledRouteTypeKeys = useMemo(() => {
    return Object.keys(disabledRouteTypes);
  }, [disabledRouteTypes]);

  return (
    <FilterDropdown
      key={data.type}
      title="Route Type"
      placement="top-start"
      items={ROUTE_TYPE_LIST_ITEMS}
      disallowEmptySelection
      disabledKeys={disabledRouteTypeKeys}
      renderCustomTrigger={(isOpen) => (
        <SuggestedSelectTrigger
          title={data.value === RouteTypeSettingsEnum.Full ? SUGGESTED_ROUTE_TYPE_NAME[data.value] : 'Partial:'}
          value={data.value === RouteTypeSettingsEnum.Full ? '' : SUGGESTED_ROUTE_TYPE_NAME[data.value]}
          isOpen={isOpen}
        />
      )}
      renderListBoxItemEndContent={(item) => {
        const tooltipText = disabledRouteTypes[item.value as RouteTypeSettingsEnum];

        return tooltipText ? (
          <Tooltip className="max-w-60" closeDelay={0} delay={0} content={tooltipText}>
            <div className="pointer-events-auto">
              <MdOutlineInfo size={16} />
            </div>
          </Tooltip>
        ) : null;
      }}
      selectedKeys={data.value ? [data.value] : []}
      mode="single"
      onSelectedKeysChange={(value) => handleRouteTypeChange(value[0] as RouteTypeSettingsEnum)}
    />
  );
};
